import { useState } from 'react';
import { Link } from 'react-router-dom';
import Arrow from '../../../components/ui/Arrow';
import SectionIntro from '../../../components/ui/SectionIntro';
import { products } from '../../../content/site';
import { localizedPath, useLocale, useMessages } from '../../../i18n/locale';
import ProductVisual from '../ProductVisual';
import FadeInOnScroll from '../../../components/effects/FadeInOnScroll';

export default function ProductsSection() {
  const locale = useLocale();
  const messages = useMessages();
  const copy = messages.home.products;
  const [activeIndex, setActiveIndex] = useState(0);
  const activeProduct = products[activeIndex];
  const activeCopy = messages.products[activeProduct.kind];
  return (
    <section id="products" className="products-section section-pad">
      <div className="container">
        <SectionIntro title={copy.title} description={copy.description} />
        <FadeInOnScroll className="products-showcase" delay={100}>
          <div className="product-switcher" role="group" aria-label={copy.selectorLabel}>
            {products.map((product, index) => (
              <button
                key={product.kind}
                className={`product-switcher__item${activeIndex === index ? ' is-active' : ''}`}
                type="button"
                aria-pressed={activeIndex === index}
                onClick={() => setActiveIndex(index)}
              >
                <span className="product-switcher__number">0{index + 1}</span>
                <span>{product.name}</span>
              </button>
            ))}
          </div>
          <div className={`product-stage product-stage--${activeProduct.kind}`}>
            <div className="product-stage__grid" aria-hidden="true" />
            <div className="product-stage__orbit" aria-hidden="true" />
            <div className="product-stage__visual" key={activeProduct.kind}>
              <ProductVisual kind={activeProduct.kind} />
            </div>
          </div>
          <div className="product-summary" aria-live="polite">
            <div key={activeProduct.kind} className="product-summary__content">
              <span>{activeCopy.type}</span>
              <h3>{activeProduct.name}</h3>
              <p>{activeCopy.description}</p>
            </div>
            <Link className="product-summary__link" to={localizedPath(locale, '/products')}>
              {copy.viewAll} <Arrow up />
            </Link>
          </div>
        </FadeInOnScroll>
      </div>
    </section>
  );
}
